/* global Webcam */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Radium, { Style } from 'radium';
import { SnackBarHelper, ActivityIndicator, Tooltip } from '@lyearn-team/frontend-components';
import autobind from 'autobind-decorator';
import showVideoResponse from 'helper/uppy/videoUploader';

import * as TinyPubSub from '../../../../helper/TinyPubSub';
import { interactionsBlocked } from '../../../../helper/blockUserInteractionHelper';
import Icon from '../../../../helper/Icon';
import User from '../../../../helper/currentUser';
import { uploadToS3 } from '../../../helper/fileUpload';

const user = new User();

@Radium
class PictureResponse extends Component {
  static contextTypes = {
    showLoading: PropTypes.func,
    hideLoading: PropTypes.func,
    getFeatureFlag: PropTypes.func
  };

  constructor(props) {
    super(props);
  }

  state = {
    freezeCamera: false,
    openCamera: false,
    uploadingImage: false,
    imageSelectedToUpload: '',
    uploadSize: false,
    showLoader: true,
    iconHover: false,
    uploadButtonClicked: false,
    // initialStage : this.props.response !== '' && this.props.isResponseEntered ? true : false,
    initialStage: this.props.response === '' || !this.props.response,
    responseToBeSubmitted: ''
  };

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.cardId !== this.props.cardId) {
      Webcam.off('live');
      Webcam.off('error');
      Webcam.reset();
    }
  }

  componentWillUnmount() {
    TinyPubSub.unsubscribe('UserInteractionBlockChange');
    Webcam.off('live');
    Webcam.off('error');
    Webcam.reset();
  }

  emptySubmittedResponse = () => {
    this.setState({ responseToBeSubmitted: '' });
  };

  getResponse = () => {
    const response = this.props.deletingResponse
      ? ''
      : this.state.responseToBeSubmitted || this.props.response;

    return {
      questionObj: this.props.questionObj,
      emptySubmittedResponse: this.emptySubmittedResponse,
      responseData: {
        questionId: this.props.questionId,
        response,
        answerEvaluation: !response || response !== '' ? '' : 'NA',
        responseType: 'IMAGE',
        deletingResponse: this.props.deletingResponse
      },
      callBack: () => {
        this.props.responseEnterChange(true);

        this.setState({
          uploadingImage: false,
          uploadSize: false,
          initialStage: true,
          imageSelectedToUpload: '',
          responseToBeSubmitted: ''
        });
      }
    };
  };

  freezeCamera(flag) {
    this.setState({ freezeCamera: flag });
  }

  changeInitialState(flag) {
    this.setState({ initialStage: flag });
  }

  openCamera(flag) {
    if (this.state.responseToBeSubmitted === '') {
      if (flag) {
        this.setState({ initialStage: false, uploadButtonClicked: false });
        this.setState({ iconHover: false });
        this.bindWebCam(flag);
      } else {
        this.setState({ openCamera: flag });
        this.freezeCamera(false);
        Webcam.reset();
      }
    }
  }

  bindWebCam(flag) {
    const self = this;
    if (flag) {
      Webcam.set({
        width: 520,
        height: 390,
        dest_width: 520,
        dest_height: 390,
        image_format: 'jpeg',
        jpeg_quality: 90,
        enable_flash: false
      });
      Webcam.attach(this.refs.camPreviewContainer);
      Webcam.on('live', () => {
        self.setState({ openCamera: flag });
        self.freezeCamera(false);
      });
      Webcam.on('error', () => {
        SnackBarHelper.showSnackbar({
          label: 'No camera access in your browser / You didn\'t "Allow" on browser prompt.',
          duration: 4
        });
      });
      return true;
    }
    return false;
  }

  @autobind
  snapShotFreezed(freezeSnapshot) {
    if (this.state.responseToBeSubmitted === '') {
      freezeSnapshot ? Webcam.freeze() : Webcam.unfreeze();
      this.freezeCamera(freezeSnapshot);
    }
  }

  dataURLtoBlob(dataurl) {
    const arr = dataurl.split(',');

    const mime = arr[0].match(/:(.*?);/)[1];

    const bstr = atob(arr[1]);

    let n = bstr.length;

    const u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new Blob([u8arr], {
      type: mime
    });
  }

  @autobind
  uploadImageFile(file) {
    const self = this;
    const fileName =
      user.id() +
      '_' +
      self.props.cardId +
      '_q' +
      self.props.position +
      'v' +
      0 +
      '_' +
      Date.now() +
      '.' +
      file.name.split('.').pop();
    const s3Url = global.constants.s3LyearnAssetsUrl + fileName;
    console.log('fileUpload:: ', file);
    const uploadPromise = uploadToS3(s3Url, file, file.type, this.uploadProgress);

    this.setState({ uploadingImage: true, uploadSize: file.size });
    uploadPromise
      .then(data => {
        self.setState(
          {
            uploadingImage: false,
            uploadSize: false,
            imageSelectedToUpload: '',
            showLoader: true,
            responseToBeSubmitted: s3Url
          },
          () => {
            this.props.saveOneResponse(this.getResponse());
          }
        );
        this.props.responseEnterChange(true);
      })
      .catch(reason => {
        console.log(reason);
      });
  }

  @autobind
  submitSnapshot() {
    const self = this;

    const imageName = encodeURIComponent(
      user.id() + '_' + self.props.cardId + '_q' + self.props.position + 'v0_' + Date.now() + '.jpg'
    );

    // https://console.aws.amazon.com/s3/home?region=us-west-2#&bucket=lyearn&prefix=assets/frontend-js/

    const s3Url = global.constants.s3LyearnAssetsUrl + imageName;

    Webcam.snap(data_uri => {
      self.setState({ responseToBeSubmitted: data_uri });

      const uploadPromise = uploadToS3(
        s3Url,
        this.dataURLtoBlob(data_uri),
        'image/jpeg',
        self.uploadProgress
      );
      self.setState({ uploadingImage: true, uploadSize: self.dataURLtoBlob(data_uri).size });

      if (this.state.imageSelectedToUpload !== '') {
        this.setState({ imageSelectedToUpload: '' });
      }
      analytics.track('IMAGE_UPLOAD_START', {
        fileName: s3Url
      });

      uploadPromise
        .then(data => {
          analytics.track('IMAGE_UPLOAD_COMPLETE', {
            fileName: s3Url
          });
          self.setState(
            {
              openCamera: false,
              freezeCamera: false,
              uploadingImage: false,
              uploadSize: false,
              /* initialStage: true, */ responseToBeSubmitted: s3Url
            },
            () => {
              this.props.saveOneResponse(this.getResponse());
            }
          );
          Webcam.reset();
          this.props.responseEnterChange(true);
        })
        .catch(reason => {
          console.log(reason);
          analytics.track('IMAGE_UPLOAD_FAILURE', {
            fileName: s3Url,
            error: reason
          });
        });
    });
  }

  @autobind
  cancelPressed() {
    this.setState({ initialStage: true });
    if (this.state.responseToBeSubmitted === '') {
      if (this.props.response !== undefined && this.props.response !== '') {
        Webcam.reset();
        this.openCamera(false);
        this.props.responseEnterChange(true);
      } else {
        this.openCamera(false);
      }
    }
    if (this.state.imageSelectedToUpload !== '') {
      this.refs.imageUploader.value = null;
      this.setState({ imageSelectedToUpload: '' });
    }
  }

  @autobind
  backToInitialStage() {
    this.setState({ initialStage: true });
    if (this.state.responseToBeSubmitted === '') {
      Webcam.reset();
      this.openCamera(false);
    }
    if (this.state.imageSelectedToUpload !== '') {
      this.refs.imageUploader.value = null;
      this.setState({ imageSelectedToUpload: '' });
    }
  }

  uploadImageSelected(url) {
    this.setState({ imageSelectedToUpload: url });
  }

  @autobind
  fileUploadChange() {
    this.setState({ initialStage: false, uploadButtonClicked: true });
    const imageUploader = this.refs.imageUploader;
    const uploadFile = imageUploader.files[0];
    if (!uploadFile) return null;
    const extension = uploadFile.name
      .split('.')
      .pop()
      .toLowerCase();
    if (['jpeg', 'jpg', 'png', 'gif'].indexOf(extension) > -1) {
      if (this.state.imageSelectedToUpload !== '') {
        this.uploadImageFile(uploadFile);
      } else {
        this.uploadImageSelected(window.URL.createObjectURL(uploadFile));
      }
    } else {
      console.log('fileupload:: ', 'INVALID FILE FORMAT');
    }
  }

  @autobind
  uploadProgress(event) {
    console.log(event.loaded, event.total);
    if (event.lengthComputable && this.refs.progressBar) {
      this.refs.progressBar.max = event.total;
      this.refs.progressBar.value = event.loaded;
    }
  }

  renderOpenCameraView() {
    const capturedImage = this.state.responseToBeSubmitted;
    return (
      <div>
        <div
          style={[
            styles.camViewContainer,
            this.state.imageSelectedToUpload === '' && !this.state.initialStage
              ? styles.displayBlock
              : styles.displayNone
          ]}
        >
          {capturedImage !== '' ? (
            <img alt="" style={styles.imageWidth} src={capturedImage} />
          ) : (
            <div
              ref="camPreviewContainer"
              className="camPreviewContainer"
              style={styles.camPreviewContainer}
            />
          )}
        </div>
        <div
          style={[
            styles.camViewContainer,
            this.state.imageSelectedToUpload !== '' && !this.state.initialStage
              ? styles.displayBlock
              : styles.displayNone
          ]}
        >
          <img style={styles.imageWidth} src={this.state.imageSelectedToUpload} />
        </div>
      </div>
    );
  }

  renderUploadedImageView() {
    return (
      <div
        style={[
          styles.camViewContainer,
          this.state.imageSelectedToUpload ? styles.displayBlock : styles.displayNone
        ]}
      >
        <img style={styles.imageWidth} src={this.state.imageSelectedToUpload} />
      </div>
    );
  }

  @autobind
  showLoader(flag) {
    this.setState({
      showLoader: flag
    });
  }

  @autobind
  renderWebCamView() {
    return this.props.response && this.props.response !== '' ? (
      <div style={[styles.displayBlock, styles.positionRelative]}>
        <div
          style={[
            styles.loadingWrapper,
            this.state.showLoader ? styles.flexWrapper : styles.displayNone
          ]}
        >
          <ActivityIndicator width={20} height={20} svgColor="#0abff1" />
        </div>
        <div
          style={[
            styles.imageWrapper,
            this.state.showLoader ? styles.displayNone : styles.displayBlock
          ]}
        >
          <img
            src={this.props.response}
            style={[styles.imageWidth]}
            onLoad={() => this.showLoader(false)}
            alt=""
          />
        </div>
      </div>
    ) : (
      <div>
        {this.renderOpenCameraView()}
        {this.renderInitialButtons(this.state.initialStage, this.state.imageSelectedToUpload)}
      </div>
    );
  }

  renderProgressBarView() {
    if (this.state.uploadingImage && !this.props.isResponseEntered) {
      return (
        <div style={styles.blockWrapper}>
          <progress ref="progressBar" value="0" style={styles.progressBar} />
          <p style={styles.fileSize}>
            File size: {window.constants.humanFileSize(this.state.uploadSize, true)}
          </p>
        </div>
      );
    }
  }

  @autobind
  hoverIcon(flag) {
    this.setState({ iconHover: flag });
  }

  renderUnFreezedButtonView() {
    if (this.state.responseToBeSubmitted || this.state.freezeCamera) return null;
    return (
      <div style={[styles.displayFlexColumn, styles.alignItemsCenter]}>
        <div style={[styles.absButtonContainer, styles.clickImageIconWrapper]}>
          <div
            style={[styles.absRecordButton]}
            key="7"
            onClick={() => this.snapShotFreezed(true)}
            onMouseOver={() => this.hoverIcon(true)}
            onMouseOut={() => this.hoverIcon(false)}
          >
            <Icon
              icon="camera-alt"
              viewBox="1 0 22 22"
              fill={this.state.iconHover ? '#0ABFF1' : '#fff'}
              size="22px"
            />
          </div>
        </div>
        <button
          style={[styles.recordButton, styles.recordButtonMargin]}
          key="3"
          value="Cancel"
          onClick={this.backToInitialStage}
        >
          Back
        </button>
      </div>
    );
  }

  renderFreezeButtonView() {
    if (!this.state.freezeCamera || this.state.uploadingImage) return null;
    return (
      <div style={styles.blockWrapper}>
        <div style={styles.flexColumnWrapper}>
          <div style={[styles.absButtonContainer, styles.retakeButtonStyle]}>
            <div
              style={styles.absRecordButton}
              key="7"
              onClick={() => this.snapShotFreezed(false)}
              onMouseOver={() => this.hoverIcon(true)}
              onMouseOut={() => this.hoverIcon(false)}
            >
              <Icon
                icon="retake-arrow"
                viewBox="0 0 28 33"
                fill={this.state.iconHover ? '#0ABFF1' : '#fff'}
                size="22px"
                svgTagAttributes={{
                  stroke: this.state.iconHover ? '#0ABFF1' : '#fff',
                  strokeWidth: '1px'
                }}
              />
            </div>
          </div>
          <div
            style={[styles.uploadButton, styles.recordButtonMargin]}
            key="10"
            onClick={this.submitSnapshot}
          >
            <div style={styles.infoIconStyle}>
              <Tooltip text="This uploads your response to our server. You still need to submit the assignment.">
                <Icon icon="info" fill="rgba(255, 255, 255, 0.68)" size="22px" />
              </Tooltip>
            </div>
            UPLOAD
          </div>
          <div style={styles.deleteButton} key="cancel" onClick={this.backToInitialStage}>
            CHANGE
            <div style={styles.infoIconStyle}>
              <Tooltip text="This deletes your response and you can attempt again.">
                <Icon icon="info" fill="rgba(118, 126, 104, 0.86)" size="22px" />
              </Tooltip>
            </div>
          </div>
        </div>
      </div>
    );
  }

  renderUploadImageButtonView() {
    return (
      <div
        style={[this.state.imageSelectedToUpload !== '' ? styles.blockWrapper : styles.displayNone]}
      >
        <div
          style={[
            this.state.uploadingImage && !this.props.isResponseEntered
              ? styles.displayNone
              : styles.flexColumnWrapper
          ]}
        >
          <div
            style={[styles.uploadButton, styles.recordButtonMargin]}
            key="20"
            onClick={this.fileUploadChange}
          >
            <div style={styles.infoIconStyle}>
              <Tooltip text="This uploads your response to our server. You still need to submit the assignment.">
                <Icon icon="info" fill="rgba(255, 255, 255, 0.68)" size="22px" />
              </Tooltip>
            </div>
            UPLOAD SELECTED PHOTO
          </div>
          <div
            style={[styles.deleteButton]}
            key="21"
            value="Cancel"
            onClick={this.backToInitialStage}
          >
            <div style={styles.infoIconStyle}>
              <Tooltip text="This deletes your response and you can attempt again.">
                <Icon icon="info" fill="rgba(118, 126, 104, 0.86)" size="22px" />
              </Tooltip>
            </div>
            CHANGE
          </div>
        </div>
      </div>
    );
  }

  fileUploaded = r => {
    TinyPubSub.unsubscribe('UserInteractionBlockChange');
    if (interactionsBlocked()) {
      TinyPubSub.subscribe(
        'UserInteractionBlockChange',
        (e, blocked) => !blocked && this.fileUploaded(r)
      );
      return false;
    }
    if (!r.url) {
      SnackBarHelper.showSnackbar({
        label: 'File Upload failed, please try again.',
        status: 'error'
      });
      window.analytics.track('FILE_UPLOAD_FAILURE', {
        errorMessage: 'Filestack callback function does not contain url to uploaded file'
      });
      return false;
    }
    const url = r.url;
    this.setState(
      {
        uploadingImage: false,
        uploadSize: false,
        imageSelectedToUpload: '',
        showLoader: true,
        responseToBeSubmitted: url
      },
      () => {
        this.props.saveOneResponse(this.getResponse());
      }
    );
    this.props.responseEnterChange(true);
  };

  uploadImage = type => () => {
    window.fs_filepicker = window.filestack && window.filestack.init('AuG7ZQSxaSemtziJGYwbsz');
    this.context.showLoading();
    let fromSources = [];
    if (type === 'upload') {
      fromSources = ['local_file_system', 'googledrive', 'webcam'];
    } else if (type === 'record') {
      fromSources = ['webcam', 'googledrive', 'local_file_system'];
    }
    window.fs_filepicker
      .picker({
        fromSources,
        maxFiles: 1,
        minFiles: 1,
        accept: ['image/*'],
        onOpen: () => {
          this.context.hideLoading();
        },
        onFileUploadFailed: (file, error) => {
          window.analytics.track('FILEPICKER_FILE_UPLOAD_FAILED', {
            cardId: this.props.cardId,
            recordOrUpload: type,
            error
          });
        },
        onFileUploadFinished: data => {
          window.analytics.track('FILEPICKER_FILE_UPLOAD_FINISHED', {
            cardId: this.props.cardId,
            fileUploadData: JSON.stringify(data),
            fileUrl: data.url,
            recordOrUpload: type
          });
          this.fileUploaded(data);
        }
      })
      .open();
  };

  renderInitialButtons(initialStage, imageSelectedToUpload) {
    const useFilestackFilePicker =
      this.context.getFeatureFlag && this.context.getFeatureFlag('use-filestack');

    return (
      <div style={styles.initialButtons}>
        <div
          style={styles.initialBtn}
          onClick={
            useFilestackFilePicker
              ? this.uploadImage('record')
              : () => showVideoResponse(this.props.cardId, this.fileUploaded, 'picture-record')
          }
        >
          <div style={styles.recordIcon} />
          <div style={styles.optIconsText}>Open Camera</div>
        </div>
        <div
          style={styles.initialBtn}
          onClick={
            useFilestackFilePicker
              ? this.uploadImage('upload')
              : () => showVideoResponse(this.props.cardId, this.fileUploaded, 'picture-upload')
          }
        >
          <Icon icon="camera-alt" viewBox="0 0 27 22" fill="#0ABFF1" size="32px" />
          <div style={styles.optIconsText}>Upload Image</div>
        </div>
      </div>
    );
  }

  renderCameraButtons() {
    if (this.state.initialStage) return null;
    return (
      <div
        style={[
          styles.mainButtonWrapper,
          this.state.openCamera ? styles.displayBlock : styles.displayNone
        ]}
      >
        {this.renderUnFreezedButtonView()}
        {this.renderFreezeButtonView()}
      </div>
    );
  }

  @autobind
  renderButtonView() {
    if (this.props.response !== undefined && this.props.response !== '') {
      if (this.props.isResponseEntered) return null;
      return (
        <div style={styles.mainButtonWrapper}>
          <div style={this.state.initialStage ? styles.flexWrapper : styles.displayNone}>
            {this.renderInitialButtons(this.state.initialStage)}
          </div>
          <div style={this.state.initialStage ? styles.displayNone : styles.flexWrapper}>
            {this.state.uploadButtonClicked
              ? this.renderUploadImageButtonView()
              : this.state.openCamera
              ? this.renderUnFreezedButtonView()
              : null}
            {this.renderFreezeButtonView()}
          </div>
        </div>
      );
    }
    return (
      <div>
        {this.renderCameraButtons()}
        <div
          style={[
            styles.mainButtonWrapper,
            this.state.imageSelectedToUpload !== '' ? styles.displayBlock : styles.displayNone
          ]}
        >
          {this.renderUploadImageButtonView()}
        </div>
      </div>
    );
  }

  render() {
    return (
      <div style={styles.pictureResponseWrapper}>
        <div style={styles.camPreviewWrapper}>
          {this.renderWebCamView()}
          {this.state.initiStage ? <div style={styles.previewLable}>YOUR RESPONSE</div> : null}
          {this.renderButtonView()}
          {this.renderProgressBarView()}
        </div>
        <Style rules={styles.classBased} />
      </div>
    );
  }
}

const styles = {
  classBased: {
    '.camPreviewContainer': {
      maxWidth: '100%'
    },
    '.camPreviewContainer > *': {
      maxWidth: '100%',
      height: 'auto'
    },
    '.camPreviewContainer': {
      maxWidth: '100%'
    }
  },

  fileSize: {
    textAlign: 'center',
    padding: '10px'
  },
  progressBar: {
    width: '80%',
    margin: '20px auto 0',
    display: 'block'
  },
  camPreviewWrapper: {
    fontFamily: 'ProximaNova',
    position: 'relative'
  },
  recordButton: {
    display: 'flex',
    padding: '12px 25px',
    // background: '#42c4e3',
    color: '#767e86',
    cursor: 'pointer',
    fontWeight: '500',
    textTransform: 'uppercase',
    fontSize: '13px',
    border: '0px',
    backgroundColor: 'transparent'
    /*    ':hover': {
      background: '#40ACC5',
    },
    ':active': {
      background: '#2C7587',
    } */
  },
  recordButtonMargin: {
    margin: '0px 10px'
  },
  mainButtonWrapper: {
    paddingTop: '20px',
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    clear: 'left'
  },
  imageUploadInput: {
    width: '0.1px',
    height: '0.1px',
    opacity: '0',
    overflow: 'hidden',
    position: 'absolute',
    zIndex: '-1'
  },
  flexWrapper: {
    display: 'flex',
    position: 'relative',
    width: '100%',
    justifyContent: 'center'
  },
  flexColumnWrapper: {
    display: 'flex',
    flexDirection: 'column',
    position: 'relative',
    width: '100%',
    justifyContent: 'center',
    alignItems: 'center'
  },
  blockWrapper: {
    display: 'block',
    position: 'relative',
    width: '100%',
    textAlign: 'center'
  },
  imageWidth: {
    maxWidth: '100%',
    position: 'relative',
    margin: '0 auto',
    maxHeight: '320px'
  },
  camPreviewContainer: {
    display: 'inline-block'
  },
  camViewContainer: {
    textAlign: 'center'
  },
  positionRelative: {
    position: 'relative'
  },
  loadingWrapper: {
    position: 'absolute',
    left: '0px',
    top: '0px',
    height: '100%',
    width: '100%',
    textAlign: 'center'
  },
  imageWrapper: {
    // position: 'absolute',
    left: '0px',
    top: '0px',
    height: '100%',
    width: '100%',
    textAlign: 'center'
  },
  imageWrapperAbs: {
    position: 'absolute'
  },
  imageWrapperRelative: {
    position: 'relative'
  },
  initialBtn: {
    backgroundColor: 'rgba(219, 226, 232, 0.24)',
    border: '1px solid rgba(118,126,134,0.24)',
    borderRadius: '2px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    width: '42.35%',
    boxSizing: 'border-box',
    padding: '16px 1% 12px',
    cursor: 'pointer'
  },
  recordIcon: {
    height: '22px',
    width: '22px',
    backgroundColor: '#0ABFF1',
    borderRadius: '50%'
  },
  optIconsText: {
    marginTop: '12px',
    fontSize: '13px',
    letterSpacing: '1px',
    color: '#767e86',
    textTransform: 'uppercase',
    fontWeight: '500'
  },
  optUploadImage: {
    marginRight: '20px',
    cursor: 'pointer'
  },
  absButtonContainer: {
    position: 'absolute',
    bottom: '75px'
  },
  absRecordButton: {
    border: '1px solid white',
    height: '40px',
    width: '40px',
    borderRadius: '50%',
    background: 'rgba(0, 0, 0, 0.36)',
    boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.26)',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  retakeButtonStyle: {
    bottom: '138px'
  },
  displayBlock: {
    display: 'block'
  },
  displayFlex: {
    display: 'flex'
  },
  displayNone: {
    display: 'none'
  },
  submitButtonDisabled: {
    display: 'none',
    position: 'relative',
    display: 'block',
    padding: '17px 96px',
    color: '#fff',
    margin: '0px 10px',
    fontWeight: '500',
    fontSize: '13px',
    background: '#c8cfd6',
    cursor: 'auto',
    marginTop: '10px'
  },
  infoIconStyle: {
    padding: '0px',
    position: 'absolute',
    top: '4px',
    right: '3px',
    height: 'auto',
    width: 'auto',
    border: 'none'
  },
  infoIconStyle1: {
    padding: '0px',
    height: 'auto',
    width: 'auto',
    border: 'none'
  },
  displayFlexColumn: {
    display: 'flex',
    flexDirection: 'column'
  },
  alignItemsCenter: {
    alignItems: 'center'
  },
  clickImageIconWrapper: {
    // bottom: '130px'
  },
  deleteButton: {
    position: 'relative',
    display: 'block',
    padding: '17px 35px',
    minWidth: '100px',
    textAlign: 'center',
    background: 'transparent',
    color: '#767e86',
    cursor: 'pointer',
    margin: '10px 10px 0',
    fontWeight: '500',
    fontSize: '13px'
  },
  initialButtons: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between'
  },
  recordIcon: {
    height: '22px',
    width: '22px',
    backgroundColor: '#0ABFF1',
    borderRadius: '50%'
  },
  uploadButton: {
    position: 'relative',
    display: 'block',
    padding: '17px 20px',
    minWidth: '248px',
    textAlign: 'center',
    background: '#42c4e3',
    color: '#fff',
    cursor: 'pointer',
    margin: '0px 10px',
    fontWeight: '500',
    fontSize: '13px',
    ':hover': {
      background: '#40ACC5'
    },
    ':active': {
      background: '#2C7587'
    }
  }
};

export default PictureResponse;
